// extracted by mini-css-extract-plugin
export var completionBody = "_jw-2";
export var completionCard = "_jw-0";
export var completionFooter = "_jw-3";
export var completionTitle = "_jw-1";